<template>
 <table class="report_basic_info report_basic_info1" cellspacing="0"  v-if="car_info && car_info.car_attr && car_info.car_attr.length>0">
     <tr>
        <td class="report_section_basic_info_attr">
            <div class="cell">车辆型号</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">车型</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">能源</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">价格</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">测试时间</div>
        </td>
    </tr>
    <tr>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ car_info.brand + " " + car_info.model_name }}
            </div>
        </td>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ car_info.year || "-"}}
            </div>
        </td>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ getEnergyType(car_info.energy_type)  || "-"}}
            </div>
        </td>
         <td class="report_section_basic_info_val">
            <div class="cell">
            {{ (car_info.price && car_info.price+" (万元)")  || "-"}}
            </div>
        </td>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ car_info.review_time  || "-"}}
            </div>
        </td>
    </tr>
    <tr class="border_top">
        <template v-for="(item,ind) in car_info.car_attr" :key="ind">
            <td class="report_section_basic_info_attr">
              <div class="cell">{{item.attr_names}}</div>
            </td>
        </template>
    </tr>
    <tr>
        <template v-for="(item,ind) in car_info.car_attr" :key="ind">
            <td class="report_section_basic_info_val">
              <div class="cell">{{item.attr_value || "-"}}</div>
            </td>
        </template>
    </tr>
 
 </table>
 <table class="report_basic_info report_basic_info2" v-else>
    <tr>
        <td class="report_section_basic_info_attr">
            <div class="cell">车辆型号</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">车型</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">系统版本</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">能源</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">测试时间</div>
        </td>
        <td class="report_section_basic_info_attr">
            <div class="cell">综合排名</div>
        </td>
    </tr>
    <tr>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ car_info.brand + " " + car_info.model_name }}
            </div>
        </td>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ car_info.year || "-"}}
            </div>
        </td>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ car_info.sys_name || "-"}}
            </div>
        </td>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ getEnergyType(car_info.energy_type)  || "-"}}
            </div>
        </td>
        <td class="report_section_basic_info_val">
            <div class="cell">
            {{ car_info.review_time  || "-"}}
            </div>
        </td>
        <td class="report_section_basic_info_val">
            <div class="cell color_E7816E">第{{ car_info.rank }}名</div>
        </td>
    </tr>
 </table>
</template>
<script>
// import { ref } from "vue";
import { getEnergyType } from "@/components/common/js/common.js";
export default {
  name: "carAttr",
  props: ["car_info"],
  setup() {
    // const data = ref(props.car_info);
    return {
    //   data,
    getEnergyType
    };
  },
};
</script>
<style lang="less" scoped>
  .report_basic_info {
      width: 920px;
      td {
        padding: 5px 10px;
        min-width: 60px;
        .cell {
          display: flex;
          justify-content: center;
          align-items: flex-start;
        }
      }
      .report_section_basic_info_attr {
        font-size: 14px;
        color: #777c89;
        white-space: nowrap;
      }
      .report_section_basic_info_val {
        font-size: 14px;
        font-weight: bold;
        color: #474747;
        vertical-align: top;
      }
    &.report_basic_info1{
        width: 900px;
        margin-left: 20px;
        .border_top{
            td{
                border-top: solid 1px #dedede;
                .cell{
                    padding: 10px 0 0;
                }
            }
        }
        td {
            .cell{
                justify-content: flex-start;
            }
        }
    }
    &.report_basic_info2{
      .report_section_basic_info_val {
        padding: 10px 0 0;
        border-top: solid 1px #dedede;
      }
    }

     
    }
</style>
